<template>
  <div class="wrapper">
    <div v-for="column in columnDefinitions" :key="column.id" :style="{ width: `${column.width}px` }">
      <ts-sorter v-if="column.sortable !== false" :sort="getSortOrder(column.id)" @click="handleSorterClick(column)">
        {{ column.name }}
      </ts-sorter>
      <div v-else-if="column.checkbox === true">
        <ts-checkbox :value="column.checked" @input="handleCheckboxChange(column, $event)"></ts-checkbox>
      </div>
      <div v-else class="header-not-sortable">
        {{ column.name }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.wrapper {
  display: flex;
}

.header-not-sortable {
  font-family: Roboto;
  font-size: 10px;
  line-height: 14px;
  color: #9aa5b7;
  display: flex;
  align-items: center;
  cursor: default;
  height: 18px;
}
</style>

<script>
export default {
  props: {
    columnDefinitions: {
      type: Array,
      default: () => []
    },
    sortedColumnId: {
      type: String,
      default: null
    },
    sortedBy: {
      type: String,
      default: null
    }
  },
  methods: {
    getSortOrder(columnId) {
      if (columnId === this.sortedColumnId) {
        return this.sortedBy;
      }
    },
    handleSorterClick(column) {
      this.$emit('sort', column.id);
    },
    handleCheckboxChange(column, value) {
      this.$emit('input', {
        column: column.id,
        value
      });
    }
  }
};
</script>
